import axios from "axios";
import apiURI from "./Api";
import { timezoneHeader } from "../utilities/timezone";

export default class LoginService {
  async postLogin(username, password) {
    const login = {
      username: username,
      password: password,
    };

    // O fuso vai só no header: a API rejeita campos a mais no corpo do login
    const response = await axios.post(`${apiURI}/login`, login, { headers: timezoneHeader() });
    return response.data;
  }

  /** Troca o código de uso único vindo da Federnet pelo token e o username ({ token, username }). */
  async exchangeFedernetHandoff(code) {
    const response = await axios.post(
      `${apiURI}/extraconomy/handoff/exchange`,
      { code },
      { headers: timezoneHeader() },
    );
    return response.data;
  }

  async getForgotPassword(email) {
    const response = await axios.get(`${apiURI}/user/requestpasswordchange/${email}`);

    return response.data;
  }

  async postConfirmPasswordChange(email, token, newPassword) {
    const passwordChangeData = {
      email: email,
      token: token,
      newpassword: newPassword,
    };

    const response = await axios.post(`${apiURI}/user/confirmpasswordchange`, passwordChangeData);

    return response.data;
  }

  async postRegisterLocation(token, latitude, longitude, username, precision) {
    const locationJson = {
      user: { username },
      longitude: longitude,
      latitude: latitude,
      precision: precision ? precision : 0,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/geolocation/registerlocation`,
      data: locationJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async postRegisterDevice(token, deviceId, typeDevice, username) {
    const deviceJson = {
      user: { username },
      typeDevice: JSON.parse(typeDevice).toUpperCase(),
      deviceid: JSON.parse(deviceId),
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/device/registerdevice`,
      data: deviceJson,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }

  async getUsername(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/user/getusername`,
      headers: { Authorization: "Bearer " + token },
    });

    return response.data;
  }
}
